'use client';
import { flushSync } from 'react-dom';
import { useRef, useState } from 'react';
import { useDidUpdate, mergeRefs } from '@s7/hooks';
import { isBrowser } from '@s7/platform';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var raf = isBrowser() ? window.requestAnimationFrame : undefined;
var collapsedStyles = {
    visibility: "collapse",
    gridTemplateRows: "0fr"
};
var openedStyles = {
    visibility: "visible",
    gridTemplateRows: "1fr"
};
var useCollapse = function(options) {
    var transitionDuration = options.transitionDuration, _options_timingFunction = options.timingFunction, timingFunction = _options_timingFunction === void 0 ? "ease" : _options_timingFunction, onTransitionEnd = options.onTransitionEnd, opened = options.opened;
    var element = useRef(null);
    var _useState = useState(opened ? {} : collapsedStyles), styles = _useState[0], setStylesRaw = _useState[1];
    var setStyles = function(newStyles) {
        flushSync(function() {
            return setStylesRaw(newStyles);
        });
    };
    var setMergedStyles = function(newStyles) {
        setStyles(function(oldStyles) {
            return _extends({}, oldStyles, newStyles);
        });
    };
    useDidUpdate(function() {
        if (opened) {
            raf == null ? void 0 : raf(function() {
                setMergedStyles(collapsedStyles);
                raf == null ? void 0 : raf(function() {
                    setMergedStyles(openedStyles);
                });
            });
        } else {
            raf == null ? void 0 : raf(function() {
                setMergedStyles(openedStyles);
                raf == null ? void 0 : raf(function() {
                    return /* visibility: 'collapse' устанавливается после закрытия, для более плавного перехода */ setMergedStyles({
                        gridTemplateRows: "0fr"
                    });
                });
            });
        }
    }, [
        opened
    ]);
    var handleTransitionEnd = function(event) {
        if (event.target !== element.current || event.propertyName !== "grid-template-rows") {
            return;
        }
        if (opened) {
            setStyles(openedStyles);
        } else {
            setStyles(collapsedStyles);
        }
        onTransitionEnd == null ? void 0 : onTransitionEnd();
    };
    return function(options) {
        if (options === void 0) options = {};
        var _options_style = options.style, style = _options_style === void 0 ? {} : _options_style, _options_refKey = options.refKey, refKey = _options_refKey === void 0 ? "ref" : _options_refKey, rest = _object_without_properties_loose(options, [
            "style",
            "refKey"
        ]);
        var theirRef = rest[refKey];
        var _obj;
        return _extends({
            "aria-hidden": !opened
        }, rest, (_obj = {}, _obj[refKey] = mergeRefs(element, theirRef), _obj.onTransitionEnd = handleTransitionEnd, _obj.style = _extends({
            boxSizing: "border-box",
            display: "grid",
            overflow: "hidden",
            transition: "grid-template-rows " + transitionDuration + "ms " + timingFunction
        }, style, styles), _obj));
    };
};

export { useCollapse };
